import { GetterTree } from 'vuex';
import { VideoModel } from '@descomplica/dex-models';
import { VideoState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<VideoState, RootState> = {
  videoById:
    (state, videosGetters) =>
    (videoId: number): VideoModel | undefined => {
      if (!videoId) {
        return undefined;
      }

      const video = state.videos[videoId.toString()];

      if (!video) {
        return undefined;
      }

      return new VideoModel(video, videosGetters);
    },
};

export default getters;
